package one.healthium.notifications.di

import one.healthium.notifications.manager.FileSaver
import one.healthium.notifications.manager.ImageFetcher
import one.healthium.notifications.scheduler.FCMNotificationProcessor
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val notificationsModule = module {
    includes(notificationsPlatformModule())
    singleOf(::FileSaver)
    singleOf(::ImageFetcher)
    singleOf(::FCMNotificationProcessor)
}